export enum VulTypes {
  TECH = 'Технічний стан',
  SANITAR = 'Санітарний стан',
  PRACTICE = 'Практика персоналу',
  // ALL = 'all',
}
